const documentSortFields = {
  doc_expire_patient: "patient",
  doc_expire_date: "expiration_date",
  doc_expire_name: "name",
  doc_expire_type: "doc_type",
};

export const getReportSortBy = (sortBy, reportSysName) => {
  if (reportSysName !== "documents-expiration") {
    return sortBy;
  }

  return (
    documentSortFields[sortBy] ||
    (Object.values(documentSortFields).includes(sortBy)
      ? sortBy
      : "expiration_date")
  );
};

export const hasMoreReportPages = (reportData) => {
  if (!reportData) {
    return false;
  }
  if (reportData.sys_name === "documents-expiration") {
    return Number(reportData.current_page) < Number(reportData.last_page);
  }
  return Boolean(reportData.next_page_url);
};

export const fetchReportData = async (getReportData, reportId, payload) => {
  const response = await getReportData(reportId, payload);
  if (
    !response ||
    (response.status !== undefined && Number(response.status) !== 200) ||
    !Array.isArray(response.data?.data)
  ) {
    throw new Error("Unable to load report. Please try again.");
  }
  return response.data;
};
